<template>
  <PageLayout show-crystal-texture>
    <!-- 加载状态 -->
    <div v-if="loading" class="loading-container">
      <div class="loading-spinner"></div>
      <p>加载中...</p>
    </div>

    <!-- 错误状态 -->
    <div v-else-if="error" class="error-container">
      <p>{{ error }}</p>
      <button class="btn-retry" @click="fetchPageData">重试</button>
    </div>

    <!-- 页面内容 -->
    <div v-else>
      <!-- 根据columnNum排序后渲染多个hero区域 -->
      <div
        v-for="item in pageDataList"
        :key="item.id"
        class="home-hero"
        :style="{ backgroundImage: `url(${item.resourceVOS[0].thumbUrl})` }"
      >
        <div class="hero-overlay"></div>
        <div class="hero-content">
          <h1>{{ item.resourceVOS[0].title }}</h1>
          <p>{{ item.resourceVOS[0].subTitle }}</p>
        </div>
        <router-link to="/series" class="btn-watch">观看影片</router-link>
      </div>
    </div>
  </PageLayout>
</template>

<script>
import PageLayout from "@/components/PageLayout.vue";

export default {
  name: "HomeView",
  components: {
    PageLayout,
  },
  data() {
    return {
      pageDataList: [],
      loading: true,
      error: "",
    };
  },
  computed: {},
  mounted() {
    this.initScrollEffect();
    this.fetchPageData();
    this.$nextTick(() => {
      this.$bus.emit('scrollTop');
    });
  },
  methods: {
    // 获取页面数据
    fetchPageData() {
      this.loading = true;
      this.error = "";

      const data = { code: "chemistry" };
      this.$api
        .getPageList(data)
        .then((result) => {
          this.loading = false;
          if (result.code === "0" && result.data && Array.isArray(result.data)) {
            // 过滤掉没有resourceVOS的项目
            this.pageDataList = result.data.filter(
              (item) => item.resourceVOS && item.resourceVOS.length > 0,
            );

            document.title = this.pageDataList[0].resourceVOS[0].title;
          } else {
            this.error = "数据格式错误，请稍后重试";
          }
        })
        .catch((err) => {
          this.loading = false;
          this.error = "获取数据失败，请稍后重试";
          console.error(err, "获取首页数据失败");
        });
    },

    // 初始化滚动效果
    initScrollEffect() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.style.opacity = "1";
              entry.target.style.transform = "translateY(0)";
            } else {
              entry.target.style.opacity = "0";
              entry.target.style.transform = "translateY(50px)";
            }
          });
        },
        {
          threshold: 0.1,
        },
      );

      // 监听所有hero区域，添加滚动动画效果
      this.$nextTick(() => {
        const heroSections = document.querySelectorAll(".home-hero");
        heroSections.forEach((section) => {
          section.style.opacity = "0";
          section.style.transform = "translateY(50px)";
          section.style.transition = "opacity 0.8s ease, transform 0.8s ease";
          observer.observe(section);
        });
      });
    },
  },
};
</script>

<style scoped>
/* 加载状态 */
.loading-container {
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 错误状态 */
.error-container {
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 0 2rem;
  text-align: center;
}

.btn-retry {
  background: transparent;
  border: 2px solid white;
  color: white;
  padding: 0.8rem 2rem;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-retry:hover {
  background: white;
  color: black;
}

/* 首页英雄区 */
.home-hero {
  height: calc(100vh - 0px);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
  padding: 0 2rem;
}

.hero-content h1 {
  font-size: clamp(2rem, 6vw, 4rem);
  margin-bottom: 1rem;
  font-weight: 300;
  letter-spacing: 0.1em;
}

.hero-content p {
  font-size: clamp(1rem, 2vw, 1.2rem);
  margin-bottom: 2rem;
  opacity: 0.8;
  letter-spacing: 0.2em;
}

.btn-watch {
  background: transparent;
  border-bottom: 2px solid white;
  color: white;
  padding: 0.2rem 0;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
  margin-top: 15rem;
  position: absolute;
  bottom: 10rem;
  left: 50%;
  transform: translateX(-50%);
}

.btn-watch:hover {
  background: white;
  color: black;
}

/* 内容区域 */
.content-section {
  min-height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4rem 0;
  position: relative;
}

.container {
  max-width: 800px;
  padding: 0 2rem;
  text-align: center;
}

.container h2 {
  font-size: clamp(1.8rem, 4vw, 2.5rem);
  margin-bottom: 2rem;
  font-weight: 300;
}

.container p {
  font-size: clamp(1rem, 2vw, 1.1rem);
  line-height: 1.8;
  opacity: 0.8;
}
</style>
